import { getElementOffset } from "../../helpers/getElementOffset";
import { getSectionMinHeight } from "../../helpers/getSectionMinHeight";
import { SectionItemI } from "../../../shared";
import {SectionInterface, Sides, SideType} from "../../types/store";
import getAvailableSectionWidths from "../../helpers/getAvailableSectionWidths";
import { useStoreRoom } from "../../useStoreRoom";
import { useStoreSystem } from "../../useStoreSystem";
import { useShelvingStore } from "../../useShelvingStore";
import { STEP_VALUE } from "../../../components/SceneObjects/room/constants";

export const getSectionId = (id: string, position: number[]) => {
    const currentShelving = useShelvingStore.getState().getCurrentShelving();
    const currentSectionId = useStoreSystem.getState().currentSectionId;

    if (!currentSectionId || !currentShelving.firstRackHeight) {
        return ['', ''];
    }

    const currentSideSections = structuredClone(currentShelving.sections);
    const currentSectionIndex = currentSideSections.findIndex((section) => section.id === currentSectionId);
    const currentItem = currentSideSections[currentSectionIndex].items.find((item) => item.id === id);

    if (!currentItem) {
        return ['', ''];
    }
    const newSectionIndex = findSectionIndex(id, position[0]);
    const sectionId = currentSideSections[currentSectionIndex].id
    const newSectionId = newSectionIndex !== null ? currentSideSections[newSectionIndex].id : sectionId;
    return [sectionId, newSectionId];
}

export const calcItemPosition = (id: string, position: number[]) => {
    const currentShelving = useShelvingStore.getState().getCurrentShelving();
    const currentSectionId = useStoreSystem.getState().currentSectionId;

    if (!currentSectionId || !currentShelving.firstRackHeight) {
        return null;
    }

    const currentSideSections = structuredClone(currentShelving.sections);
    const currentSectionIndex = currentSideSections.findIndex((section) => section.id === currentSectionId);
    const currentItem = currentSideSections[currentSectionIndex].items.find((item) => item.id === id);

    if (!currentItem) {
        return null;
    }

    const totalHeight = currentShelving.height;

    let y = position[1];

    const newSectionIndex = findSectionIndex(id, position[0]); //TODO тут вернул null...

    if (newSectionIndex === null || currentSideSections[newSectionIndex].isIndent) {
        return null;
    }

    let minHeight = getMinHeight(currentSideSections[currentSectionIndex], currentItem, newSectionIndex);
    let maxHeight = getMaxHeight(currentItem);


    //TODO Melnikov: необходимо добавить высоту от центральной позиции до низа в админке для элемента, чтобы ограничивать передвижение в крайних положениях
    let offsetItemHeight = 0
    if (currentItem.type.includes('shelf')) {
        offsetItemHeight = STEP_VALUE / 2000
    }
    //Откидные столы
    if (currentItem.type.includes('workbench')) {
        offsetItemHeight = -STEP_VALUE / 2000
    }
    //Перфорированные панели
    if (currentItem.type.includes('punchPanel')) {
        offsetItemHeight = -STEP_VALUE / 2000
    }
    //Шкафы навесные
    if (currentItem.type.includes('locker')) {
        offsetItemHeight = -STEP_VALUE / 2000
    }
    //Подвесы
    if (currentItem.type.includes('railing')) {
        offsetItemHeight = -STEP_VALUE / 2000
    }

    if (y < minHeight + offsetItemHeight || y > maxHeight + offsetItemHeight) {
        return null;
    }

    if (!getAvailableSectionWidths(currentSideSections, newSectionIndex).includes(currentItem.width)) {
        return null;
    }

    const itemPosX = (currentSideSections[newSectionIndex].offset - 2) / 1000 + currentItem.width / 2000;
    const itemPosY = calcPositionY(y, totalHeight, minHeight);

    return [itemPosX, itemPosY, currentItem.position[2]];
};

export const getMaxHeight = (currentItem: SectionItemI) => {
    const currentShelving = useShelvingStore.getState().getCurrentShelving();
    const parts = useStoreSystem.getState().parts;
    const offsetCeiling = currentShelving.offsetCeiling;
    const roomHeight = useStoreRoom.getState().height;

    let maxHeight =
        (roomHeight - offsetCeiling - (currentItem.type.includes("shelf") ? currentItem.height / 2 : currentItem.height)) / 1000 - getElementOffset(currentItem.brackets, parts);

    //TODO MELNIKOV 04.04.2023 необходимо поменять центр модели для полки и добавить высоту.
    if (currentItem.type.includes("shelf")) {
        maxHeight += 0.05;
    }

    return maxHeight;
};

export const getMinHeight = (
    currentSideSection: SectionInterface,
    currentItem: SectionItemI,
    newSectionIndex: number
) => {
    const currentShelving = useShelvingStore.getState().getCurrentShelving();
    const parts = useStoreSystem.getState().parts;
    let minHeight = 0;
    //Для элементов, которые располагаются на 2 секции.
    if (currentSideSection.width < currentItem.width) {
        minHeight =
            Math.max(
                getSectionMinHeight(currentShelving, newSectionIndex),
                getSectionMinHeight(currentShelving, newSectionIndex + 1)
            ) + getElementOffset(currentItem.brackets, parts);
    } else {
        minHeight = getSectionMinHeight(currentShelving, newSectionIndex);
    }

    return minHeight;
};

export const calcPositionY = (cursorY: number, totalHeight: number, minHeight: number): number => {
    let y: number = cursorY;
    const stepValue = STEP_VALUE;
    const stepMeters = stepValue / 1000;

    const firstSlot = minHeight + stepMeters;
    const values = new Array(Math.ceil(totalHeight / stepValue))
        .fill(undefined)
        .map((_value, index) => Math.round((firstSlot + stepMeters * index) * 1000) / 1000);

    values.forEach((value) => {
        if (Math.round(Math.abs(value * 1000 - cursorY * 1000)) < stepValue) {
            y = value;
            return;
        }
    });
    return y;
};

export const findSectionIndex = (id: string, cursorX: number) => {
    const currentShelving = useShelvingStore.getState().getCurrentShelving();
    const currentSide = useStoreSystem.getState().currentSide
    const currentSideSections = structuredClone(currentShelving.sections);
    const currentSectionId = useStoreSystem.getState().currentSectionId;
    const currentSectionIndex = currentSideSections.findIndex((section) => section.id === currentSectionId);
    if (currentSectionIndex < 0) {
        return null;
    }
    const currentItem = currentSideSections[currentSectionIndex].items.find((item) => item.id === id);

    if (!currentItem) {
        return null;
    }

    const sideWalls: Array<Partial<SideType>> = ['left' , 'right']
    const roomLength = sideWalls.includes(currentSide) ? useStoreRoom.getState().depth : useStoreRoom.getState().length;
    const sideIndent = currentShelving.sideIndent;
    const index = currentSideSections.findIndex((section) => section.id === currentItem.sectionID);
    const currentItemFrom = currentSideSections[index].offset;
    const currentItemTo = currentSideSections[index].offset + currentItem.width;
    const cursorPosXInRoom = roomLength / 2 + cursorX * 1000 - sideIndent;

    const newSectionIndex = currentSideSections.findIndex((section, i, arr) => {
        if (cursorPosXInRoom > currentItemFrom && cursorPosXInRoom < currentItemTo) {
            if (cursorPosXInRoom > currentItemFrom + currentSideSections[index].width) {
                return index + 1 === i;
            }
            return index === i;
        }
        return section.offset < cursorPosXInRoom && cursorPosXInRoom < section.offset + section.width;
    });
    if (newSectionIndex < 0) {
        return null;
    }

    return newSectionIndex;
};

